export const SEND_SMS_OTP_REQUEST = "SEND_SMS_OTP_REQUEST";
export const SEND_SMS_OTP_SUCCESS = "SEND_SMS_OTP_SUCCESS";
export const SEND_SMS_OTP_FAILURE = "SEND_SMS_OTP_FAILURE";

export const SMS_OTP_SIGNIN_REQUEST = "SMS_OTP_SIGNIN_REQUEST";
export const SMS_OTP_SIGNIN_SUCCESS = "SMS_OTP_SIGNIN_SUCCESS";
export const SMS_OTP_SIGNIN_FAILURE = "SMS_OTP_SIGNIN_FAILURE";

export const EMAIL_OTP_REQUEST = "EMAIL_OTP_REQUEST";
export const EMAIL_OTP_SUCCESS = "EMAIL_OTP_SUCCESS";
export const EMAIL_OTP_FAILURE = "EMAIL_OTP_FAILURE";

export const EMAIL_VERIFICATION_REQUEST = "EMAIL_VERIFICATION_REQUEST";
export const EMAIL_VERIFICATION_SUCCESS = "EMAIL_VERIFICATION_SUCCESS";
export const EMAIL_VERIFICATION_FAILURE = "EMAIL_VERIFICATION_FAILURE";

export const CLEAR_AUTH_STATE = "CLEAR_AUTH_STATE";

export const SIGNUP_REQUEST = "SIGNUP_REQUEST";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const SEND_RESET_PASSWORD_REQUEST = "SEND_RESET_PASSWORD_REQUEST";
export const SEND_RESET_PASSWORD_SUCCESS = "SEND_RESET_PASSWORD_SUCCESS";
export const SEND_RESET_PASSWORD_FAILURE = "SEND_RESET_PASSWORD_FAILURE";

export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";
